module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column--half-et center spacer--small"
  }, [(_vm.hasAnimationData) ? _c('expressive-type-animation', {
    attrs: {
      "bus": _vm.bus,
      "options": {
        loop: false,
        animationData: _vm.animationData
      },
      "type-index": _vm.typeIndex,
      "lang": _vm.lang,
      "blurring": _vm.blurring
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasAnimationData) ? _c('img', {
    attrs: {
      "src": ("/static/images/expressive-type/" + _vm.code + ".svg"),
      "alt": _vm.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text--brown caption caps"
  }, [_vm._v("Typeface")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caps bold"
  }, [_vm._v(_vm._s(_vm.name))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69fcbab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExpressiveTypeSubSection.vue
// module id = 147
// module chunks = 0